<template>
  <div>
    <div v-if="index===9" id="comment"></div> 
    <li class="clearfix">      
      <div v-show="senderType===0">
        <div class="message-data align-right">
          <span class="message-data-time">{{ data.msgTime }}</span>
          <span class="message-data-name">{{ data.UserName }}</span>
          <i class="fa fa-circle me"></i>
        </div>
      </div>
      <div v-show="senderType===1">
        <div class="message-data align-left">
          <i class="fa fa-circle online"></i>
          <span class="message-data-name">{{ data.UserName }}</span>
          <span class="message-data-time">{{ data.msgTime}}</span>
        </div>
      </div>
      <div v-show="senderType===99">
        <div class="message system-message">
          <p>{{ data.Text}}</p>
        </div>
      </div>
      <div v-if="senderType!=99">
        <TextMessage v-if="data.msgType === 'text'" :data="data"/>
        <StickerMessage v-else-if="data.msgType === 'emoji'" :data="data"/>
        <FileMessage v-else-if="data.msgType === 'file'" :data="data"/>
        <ImageMessage v-else-if="data.msgType === 'image'" :data="data"/>
        <VideoMessage v-else-if="data.msgType === 'video'" :data="data"/>
      </div>
    </li>
  </div>
</template>
<script>
import Global from "@/components/Global";
import TextMessage from "@/components/TextMessage.vue";
import StickerMessage from "@/components/StickerMessage.vue";
import FileMessage from "@/components/FileMessage.vue";
import ImageMessage from "@/components/ImageMessage.vue";
import VideoMessage from "@/components/VideoMessage.vue";

export default {
  name: "message",
  props: ["data", "index"],
  components: {
    TextMessage,
    StickerMessage,
    FileMessage,
    ImageMessage,
    VideoMessage
  },
  computed: {
    senderType() {
      return this.data.senderType;
    }
  },
  data() {
    return {};
  }
};
</script>

<style scoped>
.message-data.align-right span.message-data-time {
  margin-right: 10px;
  margin-left: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Message.vue